<div class="fixed top-20 right-5 z-[9999] space-y-3">
  @for(toast of notificationService.toasts$ | async; track toast.id) {
    <div class="flex items-center gap-3 px-4 py-3 min-w-[300px] max-w-[400px] rounded-xl
                shadow-[0_8px_30px_rgba(0,0,0,0.12)] text-sm font-medium animate-slide-up
                backdrop-blur-xl border"
      [ngClass]="{
        'bg-emerald-50/90 text-emerald-800 border-emerald-200': toast.type === 'success',
        'bg-rose-50/90 text-rose-800 border-rose-200': toast.type === 'error',
        'bg-blue-50/90 text-blue-800 border-blue-200': toast.type === 'info'
      }">
      <div class="w-8 h-8 rounded-full flex items-center justify-center shrink-0"
        [ngClass]="{
          'bg-emerald-500 text-white': toast.type === 'success',
          'bg-rose-500 text-white': toast.type === 'error',
          'bg-blue-500 text-white': toast.type === 'info'
        }">
        @if(toast.type === 'success') { <span class="text-sm">✓</span> }
        @else if(toast.type === 'error') { <span class="text-sm">!</span> }
        @else { <span class="text-sm">i</span> }
      </div>
      <span class="flex-1">{{ toast.message }}</span>
      <button class="w-6 h-6 rounded-full flex items-center justify-center opacity-50 hover:opacity-100
                     hover:bg-black/10 transition-all cursor-pointer text-xs"
              (click)="notificationService.removeToast(toast.id)">✕</button>
    </div>
  }
</div>
